// src/utils/labels.js
import { dynamicFields, NONE_LABEL_KEY } from '../shared/constants.js';

/**
 * Ottiene l'etichetta tradotta per un campo dinamico.
 * @param {string} field - Nome del campo
 * @param {Function} t   - Funzione di traduzione da useTranslation()
 * @returns {string}
 */
export function getFieldLabel(field, t) {
    if (dynamicFields[field]) {
        return t(dynamicFields[field].labelKey, field);
    }
    // Fallback: converti camelCase in testo leggibile
    return field
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, str => str.toUpperCase())
        .trim();
}

/**
 * Ottiene l'etichetta tradotta per un valore di filtro.
 * @param {string} value - Valore del filtro
 * @param {Function} t   - Funzione di traduzione da useTranslation()
 * @returns {string}
 */
export function getValueLabel(value, t) {
    if (value === '__NONE__' || value === null || value === undefined) {
        return t(NONE_LABEL_KEY);
    }
    return String(value);
}

/**
 * Formatta un valore per la visualizzazione.
 * Le unità fisiche (km, m, h) sono universali — non richiedono traduzione.
 * @param {string} field - Nome del campo
 * @param {any}    value - Valore da formattare
 * @returns {string}
 */
export function formatValue(field, value) {
    if (value === '__NONE__' || value === null || value === undefined) {
        return '—';
    }
    switch (field) {
        case 'lengthKm':
            return `${value} km`;
        case 'ascentMeters':
        case 'descentMeters':
            return `${value} m`;
        case 'totalDurationMin': {
            const hours = Math.floor(value / 60);
            const mins = value % 60;
            return hours > 0 ? `${hours}h ${mins}m` : `${mins}m`;
        }
        case 'elevationMin':
        case 'elevationMax':
            return `${value} m s.l.m.`;
        default:
            return String(value);
    }
}

/**
 * Ottiene l'icona per un campo (invariata, le emoji sono universali).
 * @param {string} field - Nome del campo
 * @returns {string}
 */
export function getFieldIcon(field) {
    const icons = {
        lengthCategory:         '📏',
        ascentCategory:         '⛰️',
        elevationRangeCategory: '📊',
        totalDurationCategory:  '⏱️',
        forest:                 '🌲',
        coastal:                '🌊',
        caiScale:               '🥾',
        difficulty:             '⚠️',
        surface:                '🛤️',
        widthCategory:          '↔️'
    };
    return icons[field] || '📌';
}
